import template from './adpSelectDropdown.html';
import controller from './adpSelectDropdown.controller';
import './adpSelectDropdown.less';

let adpSelectDropdownComponent = {
  restrict: 'E',
  bindings: {
    label: "@",
    opened: "=?",
  },
  template,
  transclude: {
    dropdown: '?dropdownContent',
  },
  controller
};

export default adpSelectDropdownComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpSelectDropdown/adpSelectDropdown.component.js